import React from 'react';
import { useDesign } from '../../context/contextDesign';
import { useTSContext } from '../../context/Dashboard/contextTScore';
import VulMis from '../../components/cards/score-card/0-vul-mis';
import CriticalVulMis from '../../components/cards/score-card/1-critical-vul-mis';
import DataBreachProbab from '../../components/cards/score-card/6-breach-probability';
import SaveScore from '../../components/cards/score-card/5-save-score';
import SecurityPosture from '../../components/cards/score-card/3-security-posture';
import PieChartView from './PieChart';

const DashboardView = () =>{
  const { zoom } = useDesign();
  const {    
    TVulScore, TCVulScore, TSaveScore,    
    breachProbability 
  } = useTSContext();
  
  return(
    <div style={{ zoom: zoom }}>
      <div className='d-flex flex-column'>
        <div className='d-flex flex-row'>
          <div className='d-flex flex-column'>
            <VulMis score={TVulScore}/>
            <CriticalVulMis score={TCVulScore}/>
            <DataBreachProbab score={breachProbability}/>
          </div>
          <div className='d-flex flex-column'>
            <SaveScore setScore={TSaveScore}/>
            <SecurityPosture />
          </div>
        </div>
        <div className='w-100'>
          <PieChartView />
        </div>      
      </div>
    </div>
  );
};

export default DashboardView;